import { filterOnlyVisible } from '@utils/auth/filter-only-visible';
import { useSession } from '@stores';

const getMenuItem = () => {
  const $session = useSession();

  return [
    {
      icon: 'calendar_today',
      text: 'Viagens',
      url: '/viagens',
      visible: $session.isCompany,
    },
    {
      icon: 'warning',
      text: 'Avisos',
      url: '/avisos',
      visible: $session.isCompany,
    },
    {
      icon: 'report',
      text: 'Incidentes',
      url: '/incidentes',
      visible: $session.isCompany,
    },
    {
      icon: 'computer',
      text: 'Operação',
      items: [
        {
          icon: 'directions_bus_filled',
          text: 'Onibus',
          url: '/onibus',
        },
        {
          icon: 'face',
          text: 'Motoristas',
          url: '/motoristas',
        },
        {
          icon: 'book',
          text: 'Treinamentos',
          url: '/treinamentos'
        }
      ],
      visible: $session.isCompany,
    },
    {
      icon: 'attach_money',
      text: 'Financeiro',
      visible: $session.isCompany && ($session.company.isCompanyNFEnabled || $session.canDo('CARTEIRA_PARCEIRO')),
      items: [
        {
          icon: 'description',
          text: 'Notas fiscais',
          url: '/financeiro/notas-fiscais',
          visible: $session.company.isCompanyNFEnabled,
        },
        {
          icon: 'account_balance_wallet',
          text: 'Carteira',
          url: '/financeiro/carteira',
          visible: $session.canDo('CARTEIRA_PARCEIRO'),
        },
        {
          icon: 'attach_money',
          text: 'Antecipação Pagamento',
          url: '/financeiro/antecipacao-pagamento',
          visible: $session.canDo('CARTEIRA_PARCEIRO'),
        },
        {
          icon: 'payments',
          text: 'Antecipação com pagamento parcelado',
          url: '/financeiro/antecipacao-parcelada',
          // `=== true`: só aparece quando o backend confirma elegibilidade (fail-closed).
          visible: $session.canDo('CARTEIRA_PARCEIRO')
            && $session.hasLendings?.antecipacao_parcelada === true,
        },
        {
          icon: 'payments',
          text: 'Empréstimos',
          url: '/financeiro/emprestimos',
          // `=== true`: legacy só aparece pra quem já tem contrato (não é mais concedido).
          visible: $session.canDo('CARTEIRA_PARCEIRO') && $session.hasLendings?.emprestimo === true,
        },
        {
          icon: 'currency_exchange',
          text: 'Reembolso',
          url: '/financeiro/reembolso',
          visible: $session.canDo('CARTEIRA_PARCEIRO'),
        },
        {
          icon: 'receipt_long',
          text: 'Multas',
          url: '/financeiro/multas',
          visible: $session.canDo('CARTEIRA_PARCEIRO'),
        },
      ],
    },
    {
      icon: 'insights',
      text: 'Relatórios',
      url: '/relatorios',
      visible: $session.isCompany,
    },
    {
      icon: 'help',
      text: 'Ajuda',
      url: '/ajuda',
    },
  ]
    .filter(filterOnlyVisible);
};

export { getMenuItem };
